import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDropzone from 'react-dropzone';
import { head, omit } from 'lodash';
import { Snackbar } from '@material-ui/core';

// TODO: Refactor `FileUpload` to use `react-dropzone` v10 with hooks
class FileUpload extends PureComponent {
  constructor(props) {
    super(props);

    this.handleFileRejected = this.handleFileRejected.bind(this);
    this.handleFileSelected = this.handleFileSelected.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      message: false,
    };
  }

  handleFileRejected(files) {
    const { errorMessage, onError } = this.props;

    if (onError) {
      onError(files);
    } else {
      this.setState({ message: errorMessage || 'Sorry, you can only upload pdf or image files.' });
    }
  }

  handleFileSelected(file) {
    if (!file) {
      this.setState({ message: 'Sorry, something went wrong. Please try again.' });
      return false;
    }

    this.onSubmit(file);
  }

  onSubmit(file) {
    const { onFileSubmit } = this.props;
    const filenameParts = file.name.split('.');
    const data = {
      name: filenameParts[0],
      extension: filenameParts.pop(),
      file,
    };

    onFileSubmit(data);
  }

  renderMessageRejected() {
    const { message } = this.state;

    return (
      <Snackbar
        open={Boolean(message)}
        message={message}
        autoHideDuration={4000}
        onClose={() => this.setState({ message: false })}
      />
    );
  }

  render() {
    const { accept, fileUploadRef, multiple, ...custom } = this.props;

    return (
      <div>
        <ReactDropzone
          ref={fileUploadRef}
          style={{ display: 'none' }}
          onDropAccepted={(acceptedFiles) => this.handleFileSelected(head(acceptedFiles))}
          onDropRejected={this.handleFileRejected}
          accept={accept || process.env.REACT_APP_FILES_ACCEPT}
          multiple={multiple || false}
          disableClick
          {...omit(custom, ['errorMessage', 'onError', 'onFileSubmit'])}
        />
        {this.renderMessageRejected()}
      </div>
    );
  }
}

FileUpload.propTypes = {
  accept: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  errorMessage: PropTypes.string,
  fileUploadRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  multiple: PropTypes.bool,
  onError: PropTypes.func,
  onFileSubmit: PropTypes.func.isRequired,
};

FileUpload.defaultProps = {
  accept: undefined,
  errorMessage: undefined,
  multiple: false,
  onError: undefined,
};

export default FileUpload;
